import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import {AddCredentialModal} from '../connections/AddCredentialModal';
import {AddStoreModal} from '../../channels/shopify/AddStoreModal';
import {ConnectShopifyClientModal} from '../../channels/shopify/ConnectShopifyClientModal';
import {AddTiendaNubeStoreModal} from '../../channels/tienda_nube/AddTiendaNubeStoreModal';
import {AddKlaviyoAccountModal} from '../../channels/klaviyo/AddKlaviyoAccountModal';
import {AddWooCommerceStoreModal} from '../../channels/woocommerce/AddWooCommerceStoreModal';
import {AddVtexStoreModal} from '../../channels/vtex/AddVtexStoreModal';
import {
    KLAVIYO_CHANNEL, SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, VTEX_CHANNEL, WOOCOMMERCE_CHANNEL,
} from '../../channels/channels';
import {isStoreChannel} from './platformsModel';

const STORE_MODALS = {
    [SHOPIFY_CHANNEL]: AddStoreModal,
    [TIENDA_NUBE_CHANNEL]: AddTiendaNubeStoreModal,
    [KLAVIYO_CHANNEL]: AddKlaviyoAccountModal,
    [WOOCOMMERCE_CHANNEL]: AddWooCommerceStoreModal,
    [VTEX_CHANNEL]: AddVtexStoreModal,
};

/**
 * Los flujos de alta de cada canal, los MISMOS de la pantalla clásica: `AddCredentialModal` para un
 * acceso (Google, Meta, TikTok, LinkedIn, DV360, GA4, Search Console y Escalafy, que adentro monta
 * `EscalafyConnectButton`) y el modal propio de cada tienda. Se montan una vez y se abren por canal
 * desde cualquier puerta: «Conectar X» de una tarjeta, «Agregar» al pie de una plataforma o el menú
 * «Conectar una plataforma».
 *
 * `onStoreConnected` relee la lista: en el clásico, conectar una tienda no la refrescaba (el callback
 * que lo hacía nunca existió). Ese bug no se arregla allá (contrato §2).
 */
export const PlatformAddFlows = forwardRef(function PlatformAddFlows({channels, onStoreConnected}, ref) {
    const modals = useRef({});
    const sendLinkModal = useRef(null);

    useImperativeHandle(ref, () => ({
        open(channel) {
            const modal = modals.current[channel];
            if (modal) modal.toggle();
        },
        sendShopifyLink() {
            if (sendLinkModal.current) sendLinkModal.current.toggle();
        },
    }), []);

    const keep = (channel) => (instance) => {
        modals.current[channel] = instance;
    };

    return (
        <>
            {channels.map((channel) => {
                if (!isStoreChannel(channel)) {
                    return <AddCredentialModal key={channel} ref={keep(channel)} channel={channel}/>;
                }
                const StoreModal = STORE_MODALS[channel];
                return <StoreModal key={channel} ref={keep(channel)} afterSuccessfulSubmit={onStoreConnected}/>;
            })}
            {channels.includes(SHOPIFY_CHANNEL) && <ConnectShopifyClientModal ref={sendLinkModal}/>}
        </>
    );
});

export default PlatformAddFlows;
